import { render, staticRenderFns } from "./UserEnrollment.vue?vue&type=template&id=39c4d0ba&"
import script from "./UserEnrollment.vue?vue&type=script&lang=js&"
export * from "./UserEnrollment.vue?vue&type=script&lang=js&"
import style0 from "../assets/scss/Gamification.scss?vue&type=style&index=0&lang=scss&"
import style1 from "./UserEnrollment.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports